import { EventEmitter } from 'events';
export class STEEmitter extends EventEmitter {
    constructor() {
        super(...arguments);
        this.on = (event, listener) => super.on(event, listener);
        this.emit = (event, ...args) => super.emit(event, ...args);
    }
}
